<script setup lang="ts">
import ReactorsState from '@/components/ReactorsState.vue';
import { onMounted } from 'vue';
import { useDataStore } from '@/stores/useDataStore';
import { fetchLightCultures } from '@/functions/fetch_tables';

const dataStore = useDataStore();

onMounted(async () => {
  await dataStore.loadBasicData();
  await fetchLightCultures();
});

import { useAuthStore } from '@/stores/useAuthStore'
const authStore = useAuthStore();
</script>

<template>
  <div v-if="authStore.scopes.includes('reader')">
    <div>
      <h1>{{ $t('reactorState') }}</h1>
    </div>

    <div>
      <ReactorsState />
    </div>
  </div>

  <div v-if="!authStore.isAuthenticated" class="centered-block">
    <h2>{{ $t('loginRequiredTitle') }}</h2>
    <p>{{ $t('loginRequiredMessage') }}</p>
  </div>
</template>